import { makeVar } from '@apollo/client';
import { features } from './constants';
export const featureFlagsVar = makeVar(features);
